
import React, { useEffect, useRef, useState } from "react";
import {
    Dropdown,
    DropdownButton,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
} from "react-bootstrap";
import { NewsFeed } from "../../config/imagesLink";
import { toast } from "react-hot-toast";
import { Form, Link } from "react-router-dom";
import axios from "../../API/axios";
import AddLocation from "./AddLocation";
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import PlaceSharpIcon from '@mui/icons-material/PlaceSharp';


const CompanyAction = ({ CompUid }) => {
    const sessionId = localStorage.getItem("sessionId");
    const userUid = localStorage.getItem("userUid");
    const dropdownRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [updateContent, setUpdateContent] = useState("");
    const [showModal, setShowModal] = useState(false);

    const openModal = () => {
        setShowModal(true);
    };
    const closeModal = () => {
        setShowModal(false);
    };
    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    const [showAddSkill, setShowAddSkill] = useState(false);

    const handleOpenAddSkill = () => setShowAddSkill(true);
    const handleCloseAddSkill = () => setShowAddSkill(false);






    return (
        <>
            <div
                className="postMenu pointer"
                onClick={() => setShowDropdown(!showDropdown)}
            >
                <MoreHorizSharpIcon className="material-symbols-sharp" />

                {showDropdown && (
                    <Dropdown.Menu
                        show={showDropdown}
                        ref={dropdownRef}
                        className="InteractionModal"
                    >

                        <Dropdown.Item as="button" className="dropdownList">
                            <Link
                                onClick={handleOpenAddSkill}
                            >
                                <div className="d-flex align-items-center">
                                    <PlaceSharpIcon className="material-symbols-sharp me-2" />
                                    <span className="dropdownTxt f-14">Add Location</span>
                                </div>
                            </Link>
                        </Dropdown.Item>

                    </Dropdown.Menu>
                )}
            </div>

            <AddLocation
                show={showAddSkill}
                handleClose={handleCloseAddSkill}
                CompUid={CompUid}
            />
        </>
    );
};

export default CompanyAction;
